/**
 * 画面サイズの購読(長文の文字サイズ計算に使う)。
 *
 * 値が変わったときだけ新しいオブジェクトを返すので、
 * `useMemo` の依存に直接渡しても毎フレーム再計算にならない。
 */

import { useEffect, useState } from 'react';
import type { Viewport } from '../logic/textFit';

/** SSR・テスト環境のフォールバック(Chromebook の基準解像度)。 */
const FALLBACK: Viewport = { width: 1366, height: 768 };

function read(): Viewport {
  if (typeof window === 'undefined') return FALLBACK;
  return {
    width: window.innerWidth || FALLBACK.width,
    height: window.innerHeight || FALLBACK.height,
  };
}

export function useViewport(): Viewport {
  const [viewport, setViewport] = useState<Viewport>(read);

  useEffect(() => {
    const update = (): void => {
      setViewport((current) => {
        const next = read();
        return next.width === current.width && next.height === current.height ? current : next;
      });
    };
    update();
    window.addEventListener('resize', update);
    return () => window.removeEventListener('resize', update);
  }, []);

  return viewport;
}
